import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { EChartsWrapper } from './echarts-wrapper';
import { createColumnChartOption, type ChartViewport } from '../lib/chart-options';
import { translateSeriesNames, type ChartData } from '@/entities/dashboard';
import type { ExportOptions, ChartExportOptions } from '@/shared/lib/export';

interface ColumnChartProps {
  data?: ChartData;
  /** Card heading; defaults to the chart's own title. */
  title?: React.ReactNode;
  height?: number | string;
  className?: string;
  loading?: boolean;
  showExport?: boolean;
  exportOptions?: {
    png?: ChartExportOptions;
    csv?: ExportOptions;
    xlsx?: ExportOptions;
  };
  exportPosition?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

const EMPTY_DATA: ChartData = {
  title: '',
  categories: [],
  series: [],
  unitLabel: '',
  metricLabel: ''
};

export const ColumnChart: React.FC<ColumnChartProps> = ({
  data,
  title = data?.title ?? '',
  height,
  className,
  loading,
  showExport,
  exportOptions,
  exportPosition
}) => {
  const { t } = useTranslation();
  const buildOption = useCallback(
    (viewport: ChartViewport) => createColumnChartOption(translateSeriesNames(data || EMPTY_DATA, t), viewport),
    [data, t]
  );

  return (
    <EChartsWrapper
      option={buildOption}
      title={title}
      height={height}
      className={className}
      loading={loading}
      showExport={showExport}
      exportOptions={exportOptions}
      exportPosition={exportPosition}
    />
  );
};
